import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { STYLEGUIDE_CATALOGS } from "./model/styleguide-copy.ts";

// The design system in use, at /design inside the app layout. It sits in the Support menu, and
// both hide behind `support-menu` (S43.04, D1371).
export const styleguideBrowserModule: BrowserModule = defineBrowserModule("styleguide")
  .withScreens({
    design: {
      path: "/design",
      title: phrase(STYLEGUIDE_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "support-menu",
      load: () => import("./ui/sections/styleguide-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "styleguide",
      group: "support",
      label: phrase(STYLEGUIDE_CATALOGS, "navLabel"),
      href: "/design",
      icon: "layers",
      order: 990,
      flag: "support-menu",
    },
  ]);
